import { defineComponent as _defineComponent } from 'vue'
import ReasonAiMyprForm from '@/components/yagiprime/ReasonAiMyprForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReasonAiMyprPanel',
  props: {
    formatData: null,
    hopeIndustryOptions: null,
    hopeJobcategoryOptions: null,
    isYagiPrime: { type: Boolean },
    inAppPayments: { type: Boolean },
    isAuthenticated: { type: Boolean },
    extracting: { type: Boolean },
    extracted: { type: Boolean },
    licences: null,
    aiUsageCount: null,
    aiMaxUsageCount: null,
    ctaState: null,
    aiResultView: { type: Boolean },
    aiResultHtml: null,
    aiIsStreaming: { type: Boolean },
    aiIsThinking: { type: Boolean },
    aiThinkingLabel: null,
    aiReasoningText: null,
    aiShowReasoning: { type: Boolean }
  },
  emits: ["update-field", "extract", "generate", "login", "apply", "register", "retry", "toggle-reasoning"],
  setup(__props: any) {





return { __sfc: true,ReasonAiMyprForm }
}

})